import { render, staticRenderFns } from "./item-modal.vue?vue&type=template&id=c1c12ba2"
import script from "./item-modal.vue?vue&type=script&lang=js"
export * from "./item-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports